function TrackEditor() {
  return <div id="track-editor"></div>;
}

export default TrackEditor;
